import type { DistributionQuarterMonth } from "./DistributionQuarterlyFields.types";

/** Month of the quarter. Quarters start in January, April, July and October. */
export const QUARTER_MONTH_OPTIONS: { value: string; label: string }[] = [
  { value: "1", label: "1st month (Jan, Apr, Jul, Oct)" },
  { value: "2", label: "2nd month (Feb, May, Aug, Nov)" },
  { value: "3", label: "3rd month (Mar, Jun, Sep, Dec)" },
];

export const parseQuarterMonth = (value: string): DistributionQuarterMonth =>
  value === "2" ? 2 : value === "3" ? 3 : 1;
